module.exports = __webpack_public_path__ + "static/Gilroy-Bold-62872c8ea5a842ef49c30bedd7b857ab.woff2";